import React, { PropTypes } from 'react';
import {
  CircularProgress,
  RaisedButton,
  Dialog,
  FlatButton,
  Stepper,
  Step,
  StepLabel,
} from 'material-ui';
import { connect } from 'react-redux';
import ImportOptions from './import-options';
import {
  getTemplatesForImport as getTemplatesForImportAction,
  clearStore,
} from '../../../../../stores/contracting/small-template-list/small-template-list-actions';
import SingleTemplate from './single-template';

class ImportFromTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInput: '',
      useCC: false,
      show: props.isTrueSupplier && !props.isAnAdmin ? 'importOwn' : 'importOptions',
    };
  }
  componentWillMount() {
    const { getTemplatesForImport, locationId, locationName } = this.props;
    getTemplatesForImport(locationId, locationName);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.locationId !== nextProps.locationId) {
      const { getTemplatesForImport, locationId, locationName } = nextProps;
      getTemplatesForImport(locationId, locationName);
    }
  }
  goToImportOwn = () => {
    if (!(this.props.templates && this.props.templates.filter(t => (t.originalContractId || t._id) !== this.props.contractId).length)) {
      this.props.openGlobalAlert({
        text: `You currently don't have templates available for import for this location/property.`,
      });
    } else {
      this.setState({ show: 'importOwn' });
    }
  };
  goToImportOptions = () => this.setState({ show: 'importOptions' });
  render() {
    const { show } = this.state;
    const {
      data: {
        forNewDraft,
        templateSelected = {},
      } = {},
      onTextFieldChangeWithKeyPath,
      locationName,
      loadingTemplates,
      templates = [],
      templatesForCC = [],
      contractId,
      openOmniImport,
      onRequestClose,
      importTemplate,
      isTrueSupplier,
    } = this.props;
    const goToOmniImport = () => openOmniImport(templatesForCC, locationName);
    const doImport = () => importTemplate({
      contractId,
      templateId: templateSelected._id || templateSelected.originalContractId,
      fieldsToImport: {
        locationFieldsToImport: [
          'General Terms & Conditions and Notes',
          'Billing Information',
          'Location Policies',
          'Check-in and Check-out Information',
          'Products',
        ],
      },
    });
    return (
      <Dialog
        open
        autoScrollBodyContent
        titleStyle={{
          padding: '12px 12px 10px',
          ...(show === 'importOptions' ? { background: '#00bcd4', color: '#fff', textAlign: 'center', fontWeight: 'bold', display: 'block' } : {}),
        }}
        title={<div className="flex-center">
          {forNewDraft ? 'Add Rates' : 'Import Rates'}
          {
            show === 'importOwn' && (
              <Stepper activeStep={1} style={{ width: '80%' }}>
                <Step>
                  <StepLabel style={{ height: '36px' }}>Import Options</StepLabel>
                </Step>
                <Step>
                  <StepLabel style={{ height: '36px' }}>Select Template</StepLabel>
                </Step>
              </Stepper>
            )
          }
        </div>}
        actionsContainerClassName="flex-tc-sb"
        actionsContainerStyle={show === 'importOptions' ? { display: 'flex', justifyContent: 'center' } : {}}
        actions={
          show === 'importOptions' ? [
            <RaisedButton
              key="dismiss"
              label="Dismiss"
              onClick={onRequestClose}
            />,
          ] : [
            isTrueSupplier ? <div/> : <RaisedButton
              key="back"
              label="Back"
              onClick={this.goToImportOptions}
            />,
            <div key="action">
              <FlatButton
                label="dismiss"
                primary
                onClick={onRequestClose}
              />
              <FlatButton
                label="Import"
                secondary
                onClick={doImport}
              />
            </div>,
          ]
        }
      >
        <div>
          {(() => {
            if (loadingTemplates && !(templates.length || templatesForCC.length)) {
              return (
                <div
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <CircularProgress size={90} thickness={4}/>
                </div>
              );
            }
            if (show === 'importOptions') {
              return (
                <div>
                  <ImportOptions
                    forNewDraft={forNewDraft}
                    templates={templates.filter(t => (t.originalContractId || t._id) !== contractId)}
                    templatesForCC={templatesForCC.filter(t => (t.originalContractId || t._id) !== contractId)}
                    docId={contractId}
                    goToOmniImport={goToOmniImport}
                    goToImportOwn={this.goToImportOwn}
                    onRequestClose={onRequestClose}
                  />
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    
                  </div>
                </div>
              );
            }
            if (show === 'importOwn') {
              if (!templates.filter(t => (t.originalContractId || t._id) !== contractId).length) {
                return (
                  <div style={{ lineHeight: '24px', color: '#000', marginTop: '1em' }}>
                    You don't have any rate sheet template available.
                  </div>
                );
              }
              return (
                <div>
                  <div style={{ lineHeight: '24px', color: '#000', marginTop: '1em' }}>Please select a rate sheet template:</div>
                  {
                    templates.filter(t => (t.originalContractId || t._id) !== contractId).map(t => (
                      <SingleTemplate
                        key={t._id || t.originalContractId}
                        selected={templateSelected && (templateSelected.originalContractId
                          ? templateSelected.originalContractId === t.originalContractId : templateSelected._id === t._id)}
                        template={t}
                        onSelect={() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'templateSelected'], value: t })}
                        onUnselect={() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'templateSelected'], value: null })}
                      />
                    ))
                  }
                </div>
              );
            }
          })()}
        </div>
      </Dialog>);
  }
}

ImportFromTemplate.propTypes = {
  data: PropTypes.object,
  locationId: PropTypes.string,
  locationName: PropTypes.string,
  contractId: PropTypes.string,
  loadingTemplates: PropTypes.bool,
  backFunc: PropTypes.func,
  onTextFieldChangeWithKeyPath: PropTypes.func,
  templates: PropTypes.array,
  templatesForCC: PropTypes.array,
  getTemplatesForImport: PropTypes.func,
  onRadioButtonClick: PropTypes.func,
  clearStore: PropTypes.func,
  openOmniImport: PropTypes.func,
  onRequestClose: PropTypes.func,
  openGlobalAlert: PropTypes.func,
  productType: PropTypes.string,
  importTemplate: PropTypes.func,
  isTrueSupplier: PropTypes.bool,
  isAnAdmin: PropTypes.bool,
};
const mapStateToProps = ({ contracting, user }) => ({
  ...contracting.smallContractTemplateList.toJS(),
  isTrueSupplier: user.getIn(['user', 'type']) === 'Supplier' && !user.get('isDummyAccount'),
  isAnAdmin: user.get('isAnAdmin'),
});

const mapDispatchToProps = (dispatch, { data: { forNewDraft } }) => ({
  getTemplatesForImport: (...argu) => dispatch(getTemplatesForImportAction(...argu)),
  clearStore: (...argu) => dispatch(clearStore(...argu)),
  openOmniImport: (templatesForCC, locationName) => dispatch({
    type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
    payload: {
      type: 'omniImport',
      data: {
        title: 'Omni Import',
        sourceTemplate: {},
        step: 'selectTemplate',
        matches: {},
        templates: templatesForCC,
        searchInput: locationName,
        forNewDraft,
      },
    },
  }),
  openGlobalAlert: payload => dispatch({
    type: 'open_global_alert',
    payload,
  }),
});
export default connect(mapStateToProps, mapDispatchToProps)(ImportFromTemplate);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/import-template/import-from-template.jsx